<template>
  <div class="item-card-container" :class="{ remove: isInCart }">
    <article>
      <figure class="img-container" @click="getOffer()">
        <b-img
          class="product-img"
          :src="`${rootUrl}${itemInfo.image_path}`"
          fluid
        ></b-img>
        <b-img
          :src="`${rootUrl}${itemInfo.image_path}`"
          fluid
          class="s"
          :class="{ 'animation-to-card': animateTo }"
        ></b-img>
      </figure>
      <div class="content">
        <h2 @click="getOffer()">{{ partOfOfferName }}</h2>
        <div class="price" @click="getOffer()">
          <span class="old"
            >{{ Math.floor(itemInfo.first_offer_price * 1.2) }} دينار
          </span>
          <span class="new">{{ itemInfo.first_offer_price }} دينار</span>
        </div>
        <b-button
          variant="outline-primary"
          v-if="!isInCart"
          @click="addToShoppingCart(itemInfo)"
        >
          <span class="shopping-card">
            <font icon="shopping-cart" />
          </span>
          <span>أضف للمشتريات</span>
        </b-button>

        <!--if  in card-->
        <b-button
          variant="outline-primary"
          v-if="isInCart"
          @click="removeFromShippingCard()"
        >
          <span class="shopping-card">
            <font icon="trash" />
          </span>
          <span>حذف من المشتريات</span>
        </b-button>
      </div>
    </article>
  </div>
</template>
<script type="text/javascript">
import { mapActions, mapState } from "vuex";
import {getStoreConfig} from "../../config";
const storeConfig = getStoreConfig();
export default {
  name: "ItemCard",
  props: ["itemInfo", "inCard"],
  data() {
    return {
      animateTo: false,
      isInCart: false,
      rootUrl: storeConfig.rootUrl,
    };
  },
  computed: {
    ...mapState(["getUserData"]),
    partOfOfferName() {
      return this.itemInfo.name.substring(0, 35) + "..";
    },
  },
  watch: {
    inCard: function () {
      this.isInCart = this.inCard;
    },
  },
  methods: {
    ...mapActions([
      "addToCart",
      "removeFromCart",
      "getOfferBody",
      "getCardItems",
    ]),
    removeFromShippingCard() {
      this.isInCart = false;
      this.removeFromCart(this.itemInfo.id);
    },
    getOffer() {
      this.$bvModal.show("offerModal");
      this.$router.push({
        name: this.$route.name,
        query: {
          productId: this.itemInfo.id,
        },
      });
      this.getOfferBody(this.itemInfo.id);
    },
    async addToShoppingCart(item) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        "عند إضافة المنتج للمشتريات سيتم تسجيل الطلب في المتجر وتجهيزه للشحن خلال 24 ساعة",
        {
          okTitle: "متابعة",
          cancelTitle: "إلغاء",
          centered: true,
          title: "تأكيد عملية الشراء",
        }
      );
      if (!confirmed) return;
      if (this.getUserData != null) {
        this.isInCart = true;
      }
      this.removeClasses();
      this.addToCart({ item });
    },
    removeClasses() {
      var element = document.getElementById("shopcard");
      var element2 = document.getElementById("shopcard2");
      var vm = this;
      setTimeout(function () {
        element.classList.remove("animated");
        element.classList.remove("bounce");

        element2.classList.remove("animated");
        element2.classList.remove("bounce");

        vm.animateTo = false;
      }, 1500);
    },
  },
  mounted() {
    this.isInCart = this.inCard;
  },
};
</script>
